import { useTranslation } from 'react-i18next';
import { FileUploadEvidenceContentType } from 'src/components/organisms/Reporting/ReportingReport/helpers';
import { DateFormats, formatDate, isValidDate } from 'src/utils/time';
import { readableFileSize } from '../FileUpload/helpers';
import { UploadedEvidenceFile } from './types';
import {
  DeletedTableRow,
  FileNameContainer,
  ResponsiveStyledIcon,
  TableCell,
} from './UploadedEvidence.styles';

interface Props {
  file: UploadedEvidenceFile | FileUploadEvidenceContentType;
  index: number;
  baseFileName: string;
}

export const DeletedEvidenceFile = ({ file, index, baseFileName }: Props) => {
  const { t } = useTranslation();
  const defaultFileName = `${baseFileName}${index + 1}`;
  const fileNameText = `${defaultFileName}.${file.fileExtension}${
    file.size ? ` ${readableFileSize(file.size)}` : ''
  }`;

  const getFormattedDeletedDate = (
    file: UploadedEvidenceFile | FileUploadEvidenceContentType,
  ) => {
    if (file.dataDeletedAt) {
      if (isValidDate(file.dataDeletedAt)) {
        return formatDate(file.dataDeletedAt, DateFormats.DAY_MONTH_YEAR);
      } else {
        return file.dataDeletedAt;
      }
    }

    return 'Unknown date';
  };

  return (
    <DeletedTableRow
      key={`deleted-${file.fileS3Path || 'file'}-${index}`}
      data-testid={`uploaded-file-deleted-${defaultFileName}`}
    >
      <td data-testid={`uploaded-evidence-file-name-${index}`}>
        <FileNameContainer>
          <ResponsiveStyledIcon
            className="uil uil-trash-alt"
            size="24px"
            color="#999"
          />
          {fileNameText}
        </FileNameContainer>
      </td>
      <TableCell data-testid={`uploaded-evidence-file-date-${index}`}>
        {formatDate(file.dateAdded, DateFormats.DAY_MONTH_YEAR)}
      </TableCell>
      <TableCell data-testid={`uploaded-evidence-file-status-${index}`}>
        {t('public.Evidence.deletedStatus')} {getFormattedDeletedDate(file)}
      </TableCell>
    </DeletedTableRow>
  );
};
